import React, {useState} from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react/macro';
import {applyLang} from '../i18n';
import {formatEventDate} from './eventDate';
import AnnualEventPage from './AnnualEventPage';
import {eventLinkProperties} from '../services/embedded-events';

// Annual variant of the maintained session selector. No automatic selection:
// registration always points to the date explicitly chosen by the visitor.
export default function AnnualEventSessions({group, sessions, context}) {
    const [selected, setSelected] = useState(null);
    const locale = context.langValue || context.lang?.value || 'fr';
    return <AnnualEventPage event={{...group, name: group.title || group.label, links: []}} context={context}>
        <section className='annual-event-page__links' aria-label={t`Choisissez votre session`}>
            <h2><Trans>Choisissez votre session</Trans></h2>
            {!sessions.length && <p role='status'><Trans>Aucune session disponible pour le moment.</Trans></p>}
            {sessions.map(source => {
                const session = applyLang(source, context.lang);
                const opened = selected === session.id;
                const id = `annual-session-${session.id}`;
                return <div key={session.id}>
                    <button type='button' disabled={!session.active} aria-expanded={opened} aria-controls={id}
                        onClick={() => setSelected(opened ? null : session.id)} className='annual-event-page__session'>
                        <span>{formatEventDate(session, locale)}<br/><small>{session.name || session.label}</small></span>
                        <span aria-hidden='true'>{opened ? '−' : '+'}</span>
                    </button>
                    <div id={id} hidden={!opened}>
                        {group.annualEventPage?.showPracticalInfo !== false && session.adresse && <div className='annual-event-page__facts'><a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(session.adresse)}`} target='_blank' rel='noopener noreferrer'>{session.adresse}</a></div>}
                        {!(session.links || []).length && <p><Trans>Aucune inscription disponible pour cette session.</Trans></p>}
                        {(session.links || []).map((sourceLink, index) => {
                            const link = applyLang(sourceLink, context.lang);
                            return <a key={index} {...eventLinkProperties(link.url, context)}>{link.kind === 'registration' ? session.annualEventPage?.ctaLabel || link.name : link.name}</a>;
                        })}
                    </div>
                </div>;
            })}
        </section>
    </AnnualEventPage>;
}
